import BookingDatalistPrintPage from "../bookings/BookingDatalistPrintPage";
import AccommodationEventPrintPage from "../events/AccommodationEventPrintPage";
import AccommodationAvailabilityPrintPage from "./AccommodationAvailabilityPrintPage";

const AccommodationOverviewPrintPage = () => {
    return (
        <div className="print-page">
            <div className="h-[280mm] overflow-hidden">
                <BookingDatalistPrintPage />
            </div>
            <div className="grid grid-cols-[320px_1fr] w-screen">
                <div className="print-one-page">
                    <AccommodationEventPrintPage />
                </div>
                <div className="">
                    <AccommodationAvailabilityPrintPage />
                </div>
            </div>
        </div>
    );
};

export default AccommodationOverviewPrintPage;
